<template>
  <div>
    <div id="wrapper" class="wrapper haslayout">
      <WebPortalHeader />
      <!--************************************
                    Main Start
            *************************************-->
      <main id="bg-main" class="bg-main Notice_mainsec">
        <!--************************************
                    DGME links Start
                *************************************-->
        <section class="haslayout st-shape-wrap">
          <div class="container-fluid">
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="webportal-contant">
                  <LeftSlider />
                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <div class="row">
                      <div class="mid_contant">
                        <div
                          class="
                            col-xs-12 col-12 col-sm-12 col-md-12 col-lg-12
                            mt-5
                          "
                        >
                          <div class="row" id="notice-board">
                            <div
                              v-if="
                                getContentDetailsPublicData.content_url != null
                                  ? true
                                  : false
                              "
                            >
                              <div class="Notice_details m-5">
                                <!-- {{getNoticeContentUrl}} -->
                                <h2>{{ getContentDetailsPublicData.title }}</h2>
                                <p>
                                  {{
                                    getContentDetailsPublicData.published_date
                                  }}
                                </p>
                                <iframe
                                  :key="getContentDetailsPublicData.title"
                                  :src="`${getContentUrl}/${getContentDetailsPublicData.content_url}`"
                                  width="700px"
                                  height="600px"
                                ></iframe>
                                <!-- <div id="example1" style="margin:auto;" class="pdfobject-container"><embed src="../../assets/images/google.pdf" class="pdfobject" type="application/pdf" style="overflow: auto; width: 100%; height: 100%;" __idm_frm__="209"></div> -->
                                <!-- <iframe src="../../assets/images/google.pdf" style="width:600px; height:500px;" frameborder="0"></iframe> -->
                                <!--                                                        <script>PDFObject.embed("../../assets/images/google.pdf", "#example1");</script>-->

                                <div
                                  id="notice-board-ticker"
                                  class="mt-3"
                                  v-html="
                                    getContentDetailsPublicData.description
                                  "
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <RightSlider />
                </div>
              </div>
            </div>
          </div>
          <div class="st-shape2">
            <img src="../../assets/images/contact-shape1.svg" alt="shape2" />
          </div>
        </section>
        <!--************************************
                    DGME links Start
                *************************************-->
      </main>
      <!--************************************
                    Main End
            *************************************-->
      <WebPortalFooter />
    </div>
  </div>
</template>

<script>
import WebPortalHeader from "../../components/webPortalLayout/WebPortalHeader.vue";
import LeftSlider from "../../components/webPortalLayout/LeftSlider";
import RightSlider from "../../components/webPortalLayout/RightSlider";
import WebPortalFooter from "../../components/webPortalLayout/WebPortalFooter";
import { baseURL2 } from "@/store/api.js";
import commentReply from "../../components/webPortalLayout/WebPortalCommentReply.vue";

export default {
  name: "Content",
  components: {
    WebPortalHeader,
    LeftSlider,
    RightSlider,
    WebPortalFooter,
    commentReply,
  },
  data() {
    return {
      contentComment: {
        portal_content_id: null,
        body: "",
      },
      loggedInData: {
        user: null,
        dgmeToken: null,
      },
      url_data: null,
      watchRed: 0,
    };
  },
  created() {
    this.loggedInData.user = JSON.parse(
      window.localStorage.getItem("currentUser")
    );
    this.loggedInData.dgmeToken = window.localStorage.getItem("dgmeToken");
    this.$store.dispatch("callHeaderFooterPublicData");
  },
  mounted() {
    let self = this;
    this.url_data = this.$route.params.id;
    this.$store.dispatch("callCotentDetailsByIdData", { id: this.url_data });
    self.$store.commit("SET_PORTAL_COMMENT_REPLY_CONFLICT_DATA", this.url_data);
  },
  watch: {},
  computed: {
    getContentDetailsPublicData() {
      let tempData = this.$store.getters.getContentDetailsPublicData;
      this.contentComment.portal_content_id = tempData.id;
      return tempData;
    },
    getContentUrl() {
      return baseURL2;
    },
    getDataForChange() {
      return this.$store.getters.getPortalCommentReplyConflictData;
    },
    loggedInPic() {
      return this.loggedInData.user.profile_image == null ? false : true;
    },
  },
  methods: {
    async postContentComment() {
      await this.$store.dispatch("addPortalComment", this.contentComment);
      this.contentComment.body = "";
      this.watchRed = 0;
      let data = { id: this.getDataForChange };
      this.$store.dispatch("callCotentDetailsByIdData", data);
      return true;
    },
    async reloadContent() {
      // await this.$store.dispatch('callCotentDetailsByIdData', this.$route.params.id);
      ////  console.log("pushed", this.$route.params.id);
      // this.$emit('reloadContent', data);
      // this.watchRed = 0;
      let data = { id: this.getDataForChange };
      this.$store.dispatch("callCotentDetailsByIdData", data);
      // this.$router.go();
    },
  },
};
</script>

<style scoped>
.row {
  display: block;
  flex-wrap: wrap;
  flex: 1 1 auto;
}
</style>
